import httpClient, { handleSuccess, handleError, apiHeader } from './httpClient'

export function getNewToken(code) {
  const params = new URLSearchParams()
  params.append('code', code)
  return httpClient.post('typetalk/get_new_token', params, apiHeader).then(handleSuccess).catch(handleError)
}

export function checkAuth() {
  return httpClient.get('typetalk/check_auth').then(handleSuccess).catch(handleError)
}

export function send(message, achievementId) {
  const params = new URLSearchParams()
  params.append('message', message)
  params.append('achievement_id', achievementId)
  return httpClient.post('typetalk/send', params, apiHeader).then(handleSuccess).catch(handleError)
}
